<template>
  <div class="leco-content">
    <div class="page-title">ユーザー削除</div>

    <!-- Info Message -->
    <div v-if="infoMsg" class="alert alert-info">
      {{ infoMsg }}</div>


    <!-- Search Input -->
    <div class="mt-4 form-group">
      <label for="userSearch">削除したいユーザーを検索してください（全ユーザー数：{{ users.length }}）。</label>
      <input type="text" class="form-control" id="userSearch" v-model="searchQuery" @input="searchUsers"
        placeholder="ユーザー名を入力（部分一致検索）" />
    </div>

    <!-- User List -->
    <div v-if="filteredUsers.length > 0" class="user-list mt-4">
      <div v-for="user in filteredUsers" :key="user.id" class="user-item p-3 mb-2 border rounded">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <strong>{{ user.name }}</strong>
            <div class="text-muted">{{ user.email }}</div>
          </div>
          <button class="btn btn-danger" @click="confirmDelete(user)">
            削除
          </button>
        </div>
      </div>
    </div>
    <div v-else-if="searchQuery" class="alert alert-warning mt-4">
      該当するユーザーが見つかりません
    </div>

    <!-- Loading Indicator -->
    <div v-if="loading" class="text-center mt-4">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <!-- Confirmation Modal -->
    <leco-confirmation-modal v-if="showDeleteConfirm" @confirm-ok="onDeleteConfirm" @confirm-cancel="onDeleteCancel"
      :confirmation_title="'ユーザー削除確認'" :confirmation_top_msg="'このユーザーを削除してよろしいですか？'" :confirmation_warn_list="[
        { msg: '※ このユーザーに関連するトレーニングやアンケートなどの情報は削除されません' },
        { msg: '※ この操作は取り消すことができません' }
      ]" />
  </div>
</template>

<script>
import { API_BASE_URL } from "@/common/config";
import axios from "axios";
import LECO_ConfirmationModal from "@/components/LECO_ConfirmationModal.vue";

export default {
  name: "LECO_UserDelete",
  components: {
    "leco-confirmation-modal": LECO_ConfirmationModal
  },
  data() {
    return {
      users: [],
      filteredUsers: [],
      searchQuery: "",
      loading: false,
      showDeleteConfirm: false,
      selectedUser: null,
      infoMsg: "",
      logger: this.$store.state.logger
    };
  },
  created() {
    this.fetchUsers();
  },
  methods: {
    fetchUsers() {
      this.loading = true;
      const api_url = API_BASE_URL + "users";
      this.logger.debug("Start to get user list");

      axios
        .get(api_url, {
          headers: {
            Authorization: this.$store.getters.currentUser.idToken.jwtToken
          }
        })
        .then((result) => {
          if ("statusCode" in result.data) {
            if (result.data.statusCode == 200) {
              this.users = result.data.body;
              this.searchUsers();
              this.logger.debug("users:");
              this.logger.debug(JSON.stringify(this.users));
              this.logger.debug("End to get user list");
            } else if (result.data.statusCode == 404) {
              this.logger.error("GET(user list) API status 404");
              this.logger.error(JSON.stringify(result));
            } else {
              this.logger.error("GET(user list) API status Unexpected error");
              this.logger.error(JSON.stringify(result));
              this.$router.push("/system-error500");
            }
          } else {
            this.logger.error("GET(user list) API Unexpected error");
            this.logger.error(JSON.stringify(result));
            this.$router.push("/system-error500");
          }
        })
        .catch((err) => {
          this.logger.error("error in getting user list");
          this.logger.error(JSON.stringify(err));
          this.$router.push("/system-error500");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    searchUsers() {
      this.infoMsg = "";

      if (!this.searchQuery) {
        this.filteredUsers = [];
        return;
      }

      const query = this.searchQuery.toLowerCase();
      this.filteredUsers = this.users.filter(user =>
        user.name.toLowerCase().includes(query) ||
        user.email.toLowerCase().includes(query)
      );
    },
    confirmDelete(user) {
      this.selectedUser = user;
      this.showDeleteConfirm = true;
    },
    onDeleteConfirm() {
      if (!this.selectedUser) return;

      const api_url = API_BASE_URL + "users/" + this.selectedUser.id;
      this.loading = true;

      axios
        .delete(api_url, {
          headers: {
            Authorization: this.$store.getters.currentUser.idToken.jwtToken
          }
        })
        .then((result) => {
          if ("statusCode" in result.data && result.data.statusCode == 200) {
            // Remove user from lists
            this.users = this.users.filter(u => u.id !== this.selectedUser.id);
            this.searchUsers();
            this.infoMsg = "ユーザーを削除しました";
            this.searchQuery = "";
          } else {
            this.logger.error("DELETE API Unexpected error");
            this.logger.error(JSON.stringify(result));
            this.$router.push("/system-error500");
          }
        })
        .catch((err) => {
          this.logger.error("error in deleting user");
          this.logger.error(JSON.stringify(err));
          this.$router.push("/system-error500");
        })
        .finally(() => {
          this.loading = false;
          this.showDeleteConfirm = false;
          this.selectedUser = null;
        });
    },
    onDeleteCancel() {
      this.showDeleteConfirm = false;
      this.selectedUser = null;
    }
  }
};
</script>

<style scoped>
.user-item {
  background-color: #fff;
  transition: background-color 0.2s;
}

.user-item:hover {
  background-color: #f8f9fa;
}

.spinner-border {
  width: 3rem;
  height: 3rem;
}
</style>
